import React, { useEffect, useState, useRef } from 'react';
import { MenuIcon, XIcon, ChevronDownIcon, FacebookIcon, YoutubeIcon, PhoneIcon, CalendarIcon, UserPlusIcon } from 'lucide-react';
type DropdownItem = {
  label: string;
  href: string;
};
type NavItem = {
  label: string;
  href?: string;
  external?: boolean;
  dropdown?: DropdownItem[];
};
const navItems: NavItem[] = [{
  label: 'Home',
  href: '/'
}, {
  label: 'Calendar',
  href: '/10.html'
}, {
  label: 'Activities',
  href: '/13.html',
  dropdown: [{
    label: 'Sporting Clays',
    href: '/18.html'
  }, {
    label: 'Sporting Clays Scores & Events',
    href: '/72.html'
  }, {
    label: 'Cowboy Action Shooting',
    href: '/16.html'
  }, {
    label: 'Steel Challenge',
    href: '/56.html'
  }, {
    label: '3-D Archery',
    href: '/17.html'
  }, {
    label: 'Jr. Rifle',
    href: '/15.html'
  }, {
    label: 'PPC Shooting',
    href: '/19.html'
  }, {
    label: 'Bowling Pin Shoots',
    href: '/42.html'
  }]
}, {
  label: 'Firearms Education',
  dropdown: [{
    label: 'Self Defense Class',
    href: '/67.html'
  }, {
    label: 'NRA Refuse to be a Victim',
    href: '/52.html'
  }, {
    label: 'NRA Range Safety Officer',
    href: '/22.html'
  }, {
    label: 'NRA First Steps Pistol',
    href: '/24.html'
  }, {
    label: 'Michigan CPL Course',
    href: '/21.html'
  }, {
    label: 'Michigan CPL Renewal',
    href: '/40.html'
  }, {
    label: 'Personal Protection Outside The Home',
    href: '/23.html'
  }, {
    label: 'CRASE',
    href: '/71.html'
  }]
}, {
  label: 'Club Info',
  dropdown: [{
    label: 'Clubhouse Rental',
    href: '/12.html'
  }, {
    label: 'Newsletter',
    href: '/48.html'
  }, {
    label: 'Range Rules',
    href: '/6.html'
  }, {
    label: 'Photo Tour',
    href: '/14.html'
  }, {
    label: 'Privacy Policy',
    href: '/35.html'
  }]
}, {
  label: 'STORE',
  href: 'https://my-store-c0b81b.creator-spring.com',
  external: true
}, {
  label: 'Contact Us',
  href: '/5.html'
}, {
  label: 'Members Area',
  dropdown: [{
    label: 'Constitution',
    href: '/64.html'
  }, {
    label: 'Policies',
    href: '/63.html'
  }, {
    label: 'FLSC Election 2026',
    href: '/62.html'
  }]
}];
export function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  const drawerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (drawerRef.current && !drawerRef.current.contains(e.target as Node)) {
        setMobileOpen(false);
      }
    }
    if (mobileOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [mobileOpen]);
  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileOpen]);
  return <>
      <header className="sticky top-0 z-50 w-full" style={{
      backgroundColor: '#1e3d2f',
      boxShadow: '0 2px 12px rgba(0,0,0,0.4)'
    }} data-id="element-215">
        {/* Top utility bar */}
        <div className="hidden md:flex items-center justify-between px-4 py-1" style={{
        backgroundColor: '#162e22',
        borderBottom: '1px solid rgba(200,168,75,0.2)'
      }} data-id="element-216">
          <div className="max-w-[1280px] w-full mx-auto flex items-center justify-between" data-id="element-217">
            <span style={{
            color: '#a0b8a8',
            fontFamily: 'Inter, sans-serif',
            fontSize: '12px'
          }} data-id="element-218">
              A member‑supported shooting sports club in Fenton,
              Michigan—ranges, sporting clays, archery, and training since 1953.
            </span>
            <div className="flex items-center gap-3" data-id="element-219">
              <a href="tel:8106297964" className="flex items-center gap-1 transition-colors" style={{
              color: '#c8a84b',
              fontFamily: 'Inter, sans-serif',
              fontSize: '12px'
            }} data-id="element-220">
                <PhoneIcon size={12} data-id="element-221" />
                (810) 629-7964
              </a>
              <a href="https://www.facebook.com/FentonLakesSportsmansClub" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="transition-opacity hover:opacity-80" style={{
              color: '#a0b8a8'
            }} data-id="element-222">
                <FacebookIcon size={13} data-id="element-223" />
              </a>
              <a href="https://www.youtube.com/FentonLakesSportsmansClub" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="transition-opacity hover:opacity-80" style={{
              color: '#a0b8a8'
            }} data-id="element-224">
                <YoutubeIcon size={13} data-id="element-225" />
              </a>
            </div>
          </div>
        </div>

        {/* Main nav bar */}
        <div className="flex items-center justify-between px-4 py-1" data-id="element-226">
          <div className="max-w-[1280px] w-full mx-auto flex items-center justify-between gap-4" data-id="element-227">
            {/* Logo */}
            <a href="/" aria-label="Fenton Lakes Sportsman's Club Home" className="flex-shrink-0" data-id="element-228">
              <img src="https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/FentonLakes-logo.png" alt="Fenton Lakes Sportsman's Club" className="h-14 md:h-16 w-auto object-contain" data-id="element-229" />
            </a>

            {/* Desktop Nav */}
            <nav className="hidden lg:flex items-center gap-0" aria-label="Main navigation" data-id="element-230">
              {navItems.map(item => <div key={item.label} className="nav-item relative group" data-id="element-231">
                  {item.dropdown ? <button className="flex items-center gap-0.5 px-2.5 py-2 font-medium rounded transition-colors" style={{
                color: '#e8e4d8',
                fontFamily: 'Inter, sans-serif',
                fontSize: '14px'
              }} onMouseEnter={() => setOpenDropdown(item.label)} onMouseLeave={() => setOpenDropdown(null)} aria-haspopup="true" aria-expanded={openDropdown === item.label} data-id="element-232">
                      {item.label}
                      <ChevronDownIcon size={12} data-id="element-233" />
                    </button> : <a href={item.href} target={item.external ? '_blank' : undefined} rel={item.external ? 'noopener noreferrer' : undefined} className="block px-2.5 py-2 font-medium rounded transition-colors" style={{
                color: item.label === 'STORE' ? '#c8a84b' : '#e8e4d8',
                fontFamily: 'Inter, sans-serif',
                fontSize: '14px'
              }} data-id="element-234">
                      {item.label}
                    </a>}
                  {item.dropdown && <div className="nav-dropdown" data-id="element-235">
                      {item.dropdown.map(sub => <a key={sub.href} href={sub.href} data-id="element-236">
                          {sub.label}
                        </a>)}
                    </div>}
                </div>)}
            </nav>

            {/* Quick Actions */}
            <div className="hidden lg:flex items-center gap-2 flex-shrink-0" data-id="element-237">
              <a href="/49.html" className="flex items-center gap-1.5 px-4 py-2 rounded text-xs font-semibold transition-all hover:opacity-90" style={{
              backgroundColor: '#c8a84b',
              color: '#1a1a1a',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-238">
                <UserPlusIcon size={13} data-id="element-239" />
                Apply
              </a>
            </div>

            {/* Mobile hamburger */}
            <button className="lg:hidden p-2 rounded" style={{
            color: '#e8e4d8'
          }} onClick={() => setMobileOpen(true)} aria-label="Open menu" data-id="element-240">
              <MenuIcon size={22} data-id="element-241" />
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Drawer Overlay */}
      {mobileOpen && <div className="fixed inset-0 z-50 flex" data-id="element-242">
          <div className="absolute inset-0 bg-black/60" onClick={() => setMobileOpen(false)} data-id="element-243" />
          <div ref={drawerRef} className="relative w-80 max-w-full h-full overflow-y-auto flex flex-col" style={{
        backgroundColor: '#1e3d2f'
      }} data-id="element-244">
            {/* Drawer header */}
            <div className="flex items-center justify-between px-5 py-4" style={{
          borderBottom: '1px solid rgba(200,168,75,0.3)'
        }} data-id="element-245">
              <img src="https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/FentonLakes-logo.png" alt="FLSC" className="h-10 w-auto" data-id="element-246" />
              <button onClick={() => setMobileOpen(false)} style={{
            color: '#e8e4d8'
          }} aria-label="Close menu" data-id="element-247">
                <XIcon size={22} data-id="element-248" />
              </button>
            </div>

            {/* Quick actions */}
            <div className="flex gap-2 px-5 py-4" data-id="element-249">
              <a href="/49.html" className="flex-1 text-center py-2.5 rounded text-sm font-semibold" style={{
            backgroundColor: '#c8a84b',
            color: '#1a1a1a',
            fontFamily: 'Inter, sans-serif'
          }} onClick={() => setMobileOpen(false)} data-id="element-250">
                Apply for Membership
              </a>
            </div>

            {/* Nav items */}
            <nav className="flex-1 px-3 pb-6" data-id="element-251">
              {navItems.map(item => <div key={item.label} data-id="element-252">
                  {item.dropdown ? <div data-id="element-253">
                      <button className="w-full flex items-center justify-between px-3 py-3 text-sm font-medium rounded" style={{
                color: '#e8e4d8',
                fontFamily: 'Inter, sans-serif'
              }} onClick={() => setOpenDropdown(openDropdown === item.label ? null : item.label)} data-id="element-254">
                        {item.label}
                        <ChevronDownIcon size={15} style={{
                  transform: openDropdown === item.label ? 'rotate(180deg)' : 'rotate(0)',
                  transition: 'transform 0.2s'
                }} data-id="element-255" />
                      </button>
                      {openDropdown === item.label && <div className="ml-3 mb-1" style={{
                borderLeft: '2px solid rgba(200,168,75,0.4)'
              }} data-id="element-256">
                          {item.dropdown.map(sub => <a key={sub.href} href={sub.href} className="block px-4 py-2.5 text-sm" style={{
                  color: '#b0c8b8',
                  fontFamily: 'Inter, sans-serif'
                }} onClick={() => setMobileOpen(false)} data-id="element-257">
                              {sub.label}
                            </a>)}
                        </div>}
                    </div> : <a href={item.href} target={item.external ? '_blank' : undefined} rel={item.external ? 'noopener noreferrer' : undefined} className="block px-3 py-3 text-sm font-medium rounded" style={{
              color: item.label === 'STORE' ? '#c8a84b' : '#e8e4d8',
              fontFamily: 'Inter, sans-serif'
            }} onClick={() => setMobileOpen(false)} data-id="element-258">
                      {item.label}
                    </a>}
                  <div style={{
              height: '1px',
              backgroundColor: 'rgba(255,255,255,0.06)',
              margin: '0 12px'
            }} data-id="element-259" />
                </div>)}
            </nav>

            {/* Drawer footer */}
            <div className="px-5 py-4 text-xs" style={{
          borderTop: '1px solid rgba(200,168,75,0.2)',
          color: '#7a9a8a',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-260">
              <div className="flex items-center gap-2 mb-2" data-id="element-261">
                <PhoneIcon size={12} data-id="element-262" />
                <a href="tel:8106297964" style={{
              color: '#c8a84b'
            }} data-id="element-263">
                  (810) 629-7964
                </a>
              </div>
              <div className="flex gap-4 mt-3" data-id="element-264">
                <a href="https://www.facebook.com/FentonLakesSportsmansClub" target="_blank" rel="noopener noreferrer" aria-label="Facebook" style={{
              color: '#a0b8a8'
            }} data-id="element-265">
                  <FacebookIcon size={18} data-id="element-266" />
                </a>
                <a href="https://www.youtube.com/FentonLakesSportsmansClub" target="_blank" rel="noopener noreferrer" aria-label="YouTube" style={{
              color: '#a0b8a8'
            }} data-id="element-267">
                  <YoutubeIcon size={18} data-id="element-268" />
                </a>
              </div>
            </div>
          </div>
        </div>}
    </>;
}